/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Moderator,
  ModeratorActivateRequest,
  ModeratorCreateRequest,
  ModeratorUpdateRequest,
  ModeratorsActivateCreate403,
  ModeratorsActivateCreate404,
  ModeratorsDestroy403,
  ModeratorsDestroy404,
  ModeratorsInformationRetrieve200,
  ModeratorsListParams,
  ModeratorsRetrieve403,
  ModeratorsRetrieve404,
  ModeratorsUpdate403,
  ModeratorsUpdate404,
  PaginatedModerator
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List all moderators. Super moderator only. Optional search on name, email, and ID. Paginated.
 * @summary List moderators
 */
export const moderatorsList = (
    params?: ModeratorsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModerator[]>(
      {url: `/api/v1/moderators/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsListQueryKey = (params?: ModeratorsListParams,) => {
    return [`/api/v1/moderators/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsList>>, TError = void>(params?: ModeratorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsList>>> = ({ signal }) => moderatorsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsList>>>
export type ModeratorsListQueryError = void

/**
 * @summary List moderators
 */
export const useModeratorsList = <TData = Awaited<ReturnType<typeof moderatorsList>>, TError = void>(
 params?: ModeratorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new moderator. Super moderator only.
 * @summary Create moderator
 */
export const moderatorsCreate = (
    moderatorCreateRequest: ModeratorCreateRequest,
 ) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorCreateRequest
    },
      );
    }
  


export const getModeratorsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCreate>>, TError,{data: ModeratorCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCreate>>, TError,{data: ModeratorCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCreate>>, {data: ModeratorCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCreate>>>
    export type ModeratorsCreateMutationBody = ModeratorCreateRequest
    export type ModeratorsCreateMutationError = void

    /**
 * @summary Create moderator
 */
export const useModeratorsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCreate>>, TError,{data: ModeratorCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCreate>>,
        TError,
        {data: ModeratorCreateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator management - requires moderator auth
 * @summary Get moderator by ID
 */
export const moderatorsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/${id}/`] as const;
    }

    
export const getModeratorsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsRetrieve>>, TError = ModeratorsRetrieve403 | ModeratorsRetrieve404>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsRetrieve>>> = ({ signal }) => moderatorsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsRetrieve>>>
export type ModeratorsRetrieveQueryError = ModeratorsRetrieve403 | ModeratorsRetrieve404

/**
 * @summary Get moderator by ID
 */
export const useModeratorsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsRetrieve>>, TError = ModeratorsRetrieve403 | ModeratorsRetrieve404>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Moderator management - requires moderator auth
 * @summary Update moderator
 */
export const moderatorsUpdate = (
    id: number,
    moderatorUpdateRequest: ModeratorUpdateRequest,
 ) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: moderatorUpdateRequest
    },
      );
    }
  


export const getModeratorsUpdateMutationOptions = <TError = ModeratorsUpdate403 | ModeratorsUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsUpdate>>, TError,{id: number;data: ModeratorUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsUpdate>>, TError,{id: number;data: ModeratorUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsUpdate>>, {id: number;data: ModeratorUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsUpdate>>>
    export type ModeratorsUpdateMutationBody = ModeratorUpdateRequest
    export type ModeratorsUpdateMutationError = ModeratorsUpdate403 | ModeratorsUpdate404

    /**
 * @summary Update moderator
 */
export const useModeratorsUpdate = <TError = ModeratorsUpdate403 | ModeratorsUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsUpdate>>, TError,{id: number;data: ModeratorUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsUpdate>>,
        TError,
        {id: number;data: ModeratorUpdateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator management - requires moderator auth
 * @summary Delete moderator
 */
export const moderatorsDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getModeratorsDestroyMutationOptions = <TError = ModeratorsDestroy403 | ModeratorsDestroy404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsDestroy>>>
    
    export type ModeratorsDestroyMutationError = ModeratorsDestroy403 | ModeratorsDestroy404

    /**
 * @summary Delete moderator
 */
export const useModeratorsDestroy = <TError = ModeratorsDestroy403 | ModeratorsDestroy404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Set moderator active status. Super moderator only.
 * @summary Activate moderator
 */
export const moderatorsActivateCreate = (
    id: number,
    moderatorActivateRequest: ModeratorActivateRequest,
 ) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/${id}/activate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorActivateRequest
    },
      );
    }
  


export const getModeratorsActivateCreateMutationOptions = <TError = ModeratorsActivateCreate403 | ModeratorsActivateCreate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsActivateCreate>>, TError,{id: number;data: ModeratorActivateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsActivateCreate>>, TError,{id: number;data: ModeratorActivateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsActivateCreate>>, {id: number;data: ModeratorActivateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsActivateCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsActivateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsActivateCreate>>>
    export type ModeratorsActivateCreateMutationBody = ModeratorActivateRequest
    export type ModeratorsActivateCreateMutationError = ModeratorsActivateCreate403 | ModeratorsActivateCreate404

    /**
 * @summary Activate moderator
 */
export const useModeratorsActivateCreate = <TError = ModeratorsActivateCreate403 | ModeratorsActivateCreate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsActivateCreate>>, TError,{id: number;data: ModeratorActivateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsActivateCreate>>,
        TError,
        {id: number;data: ModeratorActivateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsActivateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns the currently logged-in moderator.
 * @summary Get current moderator
 */
export const moderatorsCurrentRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<Moderator>(
      {url: `/api/v1/moderators/current/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsCurrentRetrieveQueryKey = () => {
    return [`/api/v1/moderators/current/`] as const;
    }

    
export const getModeratorsCurrentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCurrentRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCurrentRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCurrentRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCurrentRetrieve>>> = ({ signal }) => moderatorsCurrentRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCurrentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCurrentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCurrentRetrieve>>>
export type ModeratorsCurrentRetrieveQueryError = void

/**
 * @summary Get current moderator
 */
export const useModeratorsCurrentRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCurrentRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCurrentRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCurrentRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns platform metrics: total companies, conversion rate, deal volume, average response time, and their month-over-month growth. Available to all moderators.
 * @summary Dashboard information (moderator / super moderator)
 */
export const moderatorsInformationRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorsInformationRetrieve200>(
      {url: `/api/v1/moderators/information/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsInformationRetrieveQueryKey = () => {
    return [`/api/v1/moderators/information/`] as const;
    }

    
export const getModeratorsInformationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsInformationRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsInformationRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsInformationRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsInformationRetrieve>>> = ({ signal }) => moderatorsInformationRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsInformationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsInformationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsInformationRetrieve>>>
export type ModeratorsInformationRetrieveQueryError = void

/**
 * @summary Dashboard information (moderator / super moderator)
 */
export const useModeratorsInformationRetrieve = <TData = Awaited<ReturnType<typeof moderatorsInformationRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsInformationRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsInformationRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



